"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNote = exports.StyledError = exports.StyledTextWrapper = exports.StyledWrapper = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var wrapperStyles = function wrapperStyles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(".dropZoneDiv{width:auto;height:100%;padding:10px;margin:5px;border:2px dashed ", color.grey2, ";border-radius:5px;text-align:center;.Icon{margin-bottom:20px;}}")
  );
};

var StyledWrapper = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("section", {
  target: "css-2rh6960"
})(wrapperStyles));
exports.StyledWrapper = StyledWrapper;

var textWrapperStyles = function textWrapperStyles(_ref2) {
  var color = _ref2.theme.color,
      withIcon = _ref2.withIcon;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-top:12.5rem;", !withIcon && "\n    margin-top: 0;\n  ", "\n  color:", color.black1, "\n  button{margin:auto;}")
  );
};

var StyledTextWrapper = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-2rh6961"
})(textWrapperStyles));
exports.StyledTextWrapper = StyledTextWrapper;

var errorStyles = function errorStyles(_ref3) {
  var color = _ref3.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", color.red)
  );
};

var StyledError = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("p", {
  target: "css-2rh6962"
})(errorStyles));
exports.StyledError = StyledError;

var noteStyles = function noteStyles(_ref4) {
  var theme = _ref4.theme;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", theme.color.black3, "\n  margin-top:11.25rem;margin-bottom:9.375rem;")
  );
};

var StyledNote = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("p", {
  target: "css-2rh6963"
})(noteStyles));
exports.StyledNote = StyledNote;